export const FETCH_PROCEDURELIST_REQUEST = "FETCH_PROCEDURELIST_REQUEST";
export const FETCH_PROCEDURELIST_SUCCESS = "FETCH_PROCEDURELIST_SUCCESS";
export const FETCH_PROCEDURELIST_FAILURE = "FETCH_PROCEDURELIST_FAILURE";
